import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <main id="main-content" className="page-shell not-found-page">
      <span>404</span>
      <h1>Report not found</h1>
      <p>The requested dashboard route is not available.</p>
      <Link to="/"><ArrowLeft aria-hidden="true" size={17} /> Return to the network</Link>
    </main>
  )
}
